import { Suspense, useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import ErrorBoundary from './error-boundary';
import { useTranslate } from 'react-admin';
import { useHistory } from 'react-router-dom';

interface Props {
    children: any;
}

const DelayedFallback = () => {
    const [show, setShow] = useState(false);
    useEffect(() => {
        let timeout = setTimeout(() => setShow(true), 1000);
        return () => {
            clearTimeout(timeout);
        };
    }, []);

    return <div>{show && <Skeleton variant="rectangular" animation="wave" width="100%" height={100} />}</div>;
};

export default function MySuspense(ops: Props) {
    const { children } = ops;
    const translate = useTranslate();
    const history = useHistory();

    return (
        <ErrorBoundary errorMsg={translate('ra.message.error')} history={history}>
            <Suspense fallback={<DelayedFallback />}>{children}</Suspense>
        </ErrorBoundary>
    );
}
